
export class FilterObj{
  pageNumber: number;
  pageSize: number;
}
